import { memo } from "react";
import { Link } from "react-router-dom";
import AutoAwesome from "@mui/icons-material/AutoAwesome";
import CloseIcon from "@mui/icons-material/Close";
import MonitorHeart from "@mui/icons-material/MonitorHeart";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { usePostAttendanceContext } from "@/contexts/PostAttendanceContext";
import { PostAttendence } from "@/pages/home/components/ProfessionalDashBoard/components/PostAttendence/PostAttendence";

export interface PostAttendenceDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Dialog FluxZap com o fluxo legado de pós-consulta (medicamentos / exames).
 */
const PostAttendenceDialog = memo(
  ({ open, onClose }: PostAttendenceDialogProps) => {
    const { contractPostAttendance } = usePostAttendanceContext();

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="lg"
        fullWidth
        aria-labelledby="fluxzap-post-attendance-dialog-title"
      >
        <DialogTitle id="fluxzap-post-attendance-dialog-title" sx={{ pr: 6 }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" fontWeight={700}>
              FluxZap
            </Typography>
            <IconButton
              aria-label="Fechar FluxZap"
              onClick={onClose}
              size="small"
              sx={{ position: "absolute", right: 12, top: 12 }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Medicamentos, exames e acompanhamento pós-consulta
          </Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ p: { xs: 1, sm: 1.5 } }}>
          {contractPostAttendance ? (
            <PostAttendence />
          ) : (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="center"
              sx={{
                backgroundColor: "neutral100.main",
                borderRadius: 2,
                p: 3,
                border: "1px dashed",
                borderColor: "neutral300.main",
              }}
            >
              <MonitorHeart sx={{ fontSize: 40, color: "primary.main" }} />
              <Stack spacing={1}>
                <Typography variant="body1" fontWeight={500}>
                  Ative a extensão FluxZap
                </Typography>
                <Typography variant="body2" color="neutral700.main">
                  Integre o número de WhatsApp da sua clínica e faça o
                  acompanhamento da jornada clínica de seu paciente de forma
                  integrada.
                </Typography>
                <Button
                  component={Link}
                  to="/extensions"
                  variant="contained"
                  startIcon={<AutoAwesome />}
                  onClick={onClose}
                  sx={{
                    mt: 1,
                    textTransform: "capitalize",
                    width: "fit-content",
                  }}
                >
                  Ativar extensão
                </Button>
              </Stack>
            </Stack>
          )}
        </DialogContent>
      </Dialog>
    );
  },
);

PostAttendenceDialog.displayName = "PostAttendenceDialog";

export default PostAttendenceDialog;
